import React, { JSX } from 'react';

import { Icon } from '@videoblocks/design-system';

export default function RightArrowButton(): JSX.Element {
    // todo: need a small / md:hidden version, a la ProminentSearchButton?
    return (
        <button
            type="submit"
            className="rounded-full border-none h-12 w-12 p-4 bg-gray-400 m-2 hidden md:block cursor-pointer transition-colors duration-300 ease-in-out hover:bg-gray-900 shrink-0 grow-0"
            aria-label="Submit Search"
        >
            <Icon name="arrowRight" className="[&_path]:fill-white" />
        </button>
    );
}
